import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    padding: tokens.spacingHorizontalM,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  keyInput: {
    flex: '1',
  },
  valueInput: {
    flex: '2',
  },
  addBtn: {
    alignSelf: 'flex-start',
    marginTop: tokens.spacingVerticalXS,
  },
});
